import { PDAuthService } from 'pdauth';
var AuthenticationService = /** @class */ (function () {
    function AuthenticationService(pdauth) {
        this.pdauth = pdauth;
        this.user = null;
        //private _user: User;
        this.permissions = null;
        this.user = pdauth.getLoggedInUser();
        //this.user.subscribe(user => this._user = user);
        this.permissions = this.pdauth.getLoggedInUserPermissions();
        //this.permissions.subscribe(permissions => this._permissions = permissions);
    }
    //private _permissions: string[];
    AuthenticationService.prototype.GetCurrentUser = function () {
        if (!this.user) {
            this.user = this.pdauth.getLoggedInUser();
        }
        return this.user;
    };
    AuthenticationService.prototype.HasPermission = function (permission) { return this.pdauth.hasPermission(permission); };
    AuthenticationService.prototype.HasAnyPermission = function () {
        var permissions = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            permissions[_i] = arguments[_i];
        }
        return this.pdauth.hasAnyPermission(permissions);
    };
    AuthenticationService.prototype.HasAllPermissions = function () {
        var permissions = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            permissions[_i] = arguments[_i];
        }
        return this.pdauth.hasAllPermissions(permissions);
    };
    return AuthenticationService;
}());
var ɵ0 = function (pdauth) {
    return window.AuthenticationService ? new window.AuthenticationService() : new AuthenticationService(pdauth);
};
var AuthenticationServiceProvider = {
    deps: [PDAuthService],
    provide: 'authenticationService',
    useFactory: ɵ0
};
export { AuthenticationServiceProvider };
export { ɵ0 };
